import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    adminFeesDescription:
      'Frais obligatoires à verser auprès des autorités compétentes pour le traitement des formalités d’entreprises (Greffe, journal d’annonces légales...)',
    adminFeesLabel: 'Frais administratifs',
    capitalDeposit: 'Dépôt du capital',
    capitalDepositDescription:
      'Le capital sera versé sur un compte séquestre chez notre notaire partenaire.',
    capitalDepositLabel: 'Dépot de capital',
    certificate: 'Délivrance de l’attestation',
    continue: 'Continue',
    contract: {
      long: 'Forfait Création SASU',
      short: 'Forfait SASU',
    },
    excludingVAT: 'excl. VAT.',
    formalitiesLabel: 'Documents et formalités',
    funds: 'Libération des fonds',
    legalAnnounce: 'Dépôt de l’annonce légale',
    legalAnnounceFees: 'Frais d’annonce légale',
    registrationFees: 'Frais d’immatriculation',
    sending: 'Envoi du dossier complet au Greffe',
    statutesWriting: 'Rédaction des projets de statuts',
    title: 'Forfait création SASU',
    total: 'Total',
    verification: 'Vérification de votre dossier par notre équipe',
  },
  fr: {
    adminFeesDescription:
      'Frais obligatoires à verser auprès des autorités compétentes pour le traitement des formalités d’entreprises (Greffe, journal d’annonces légales...)',
    adminFeesLabel: 'Frais administratifs',
    capitalDeposit: 'Dépôt du capital',
    capitalDepositDescription:
      'Le capital sera versé sur un compte séquestre chez notre notaire partenaire.',
    capitalDepositLabel: 'Dépot de capital',
    certificate: 'Délivrance de l’attestation',
    continue: 'Continuer',
    contract: {
      long: 'Forfait Création SASU',
      short: 'Forfait SASU',
    },
    excludingVAT: 'HT',
    formalitiesLabel: 'Documents et formalités',
    funds: 'Libération des fonds',
    legalAnnounce: 'Dépôt de l’annonce légale',
    legalAnnounceFees: 'Frais d’annonce légale',
    registrationFees: 'Frais d’immatriculation',
    sending: 'Envoi du dossier complet au Greffe',
    statutesWriting: 'Rédaction des projets de statuts',
    title: 'Forfait création SASU',
    total: 'Total',
    verification: 'Vérification de votre dossier par notre équipe',
  },
} as const);
